/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { ComponentClassNames, mergeStyleSets } from "@microsoft/shifts-ui-core";

type TypeManagerResponseStyles = "stack" | "divider" | "text";
/**
 * Gets the 'MemberRequest' component CSS class names.
 * @returns The 'MemberRequest' component CSS class names.
 */
export const getClassNames = (): ComponentClassNames<TypeManagerResponseStyles> => {
    const backgroundColour = "var(--subdom6)";
    const textColour = "var(--app-gray-02)";

    return mergeStyleSets({
        stack: {
            padding: "0.5rem 0"
        },
        divider: {
            width: "100%",
            height: "0.063rem",
            backgroundColor: `${backgroundColour}`,
            marginBottom: "0.5rem"
        },
        text: {
            color: `${textColour}`,
            whiteSpace: "normal",
            wordWrap: "break-word",
            overflowWrap: "break-word"
        }
    });
};
